import { render } from "./banque.vue?vue&type=template&id=af8a0062&scoped=true"
import script from "./banque.vue?vue&type=script&lang=js"
export * from "./banque.vue?vue&type=script&lang=js"

import "./banque.vue?vue&type=style&index=0&id=af8a0062&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8a0062"]])

export default __exports__